module.exports = __webpack_public_path__ + "img/AccountingDonutPending.7bfa71eb.png";